// Orange2 layout entrypoint
// Migrated from app/assets/javascripts/orange2.js

import Fingerprint2 from 'fingerprintjs2'
window.Fingerprint2 = Fingerprint2

// AT-1239: jquery-global eerst, net als red, red2, yellow en admin2. Het is een gedeelde
// chunk en draait dus vóór de chunks van bootstrap en bootbox. libraries/globals zat
// alleen nog in dit entrypoint, werd in deze chunk ingevoegd en draaide pas ná bootbox;
// bootbox legde dan de jQuery uit de <script>-tag vast, zonder Bootstrap-modal, en
// elke bootbox-melding gaf "t.modal is not a function". Zolang orange.js bestond deelden
// die twee globals en ging het toevallig goed.
import 'libraries/jquery-global'
import 'libraries/globals' // angular en underscore als window globals (jQuery staat er dan al)
import 'angular-resource'
import 'vendor/checklist-model'
import 'jquery-ujs'
import 'vendor/bootstrap-validator'
// i18n + i18n/translations loaded via <script> tags in layout (gem-generated)
import 'popper.js'
import 'bootstrap'
import 'vendor/ui-bootstrap-tpls-0.3.3'
import 'vendor/bootbox-4.3.0'
import 'libraries/service-cost'
import 'libraries/order'
// resizer + iframeResizer.contentWindow loaded as sync <script> in layout
import toastr from 'toastr'
window.toastr = toastr
import 'intl-tel-input'
import 'libraries/idle'
import 'libraries/orange2-legacy'
import 'libraries/share-panel'

// Manual Angular bootstrap - required because Vite modules are deferred
// and ng-app auto-bootstrap may fire before myApp module is registered.
// ng-app="myApp" has been removed from the layout's <html> tag.
document.addEventListener('DOMContentLoaded', function() {
  window.angular.bootstrap(document, ['myApp'])
})
